// Crop presets matching the display dimensions used by the online shop.
// Keep ratios in sync with the shop's CSS aspect-ratio values.
export const CROP_PRESETS = {
  heroSlide: { aspectRatio: 16 / 5, width: 1920, height: 600, label: '1920 × 600 (16:5)' },
  sideBanner: { aspectRatio: 16 / 5, width: 960, height: 300, label: '960 × 300 (16:5)' },
  banner: { aspectRatio: 4, width: 1600, height: 400, label: '1600 × 400 (4:1)' },
  bannerTile: { aspectRatio: 3 / 2, width: 1200, height: 800, label: '1200 × 800 (3:2)' },
  storeBackground: { aspectRatio: 16 / 5, width: 1920, height: 600, label: '1920 × 600 (16:5)' },
  product: { aspectRatio: 1, width: 800, height: 800, label: '800 × 800 (1:1)' },
  category: { aspectRatio: 1, width: 600, height: 600, label: '600 × 600 (1:1)' },
  logo: { aspectRatio: 1, width: 400, height: 400, type: 'image/png', label: '400 × 400 (1:1, PNG)' },
}

export default CROP_PRESETS
